<template>
	<div class="baground">
		<img class="logo" v-if="name.startsWith('http')" :src="name" />
		<div>
			<b-alert v-if="error" show>{{ errorMsg }}</b-alert>
		</div>
	</div>
</template>

<script>
	import register from "../services/register.js";
	import store from "../store";

	export default {
		name: "register_check",
		data() {
			return {
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || "Smartmydata",
			};
		},
		methods: {
		},
		mounted()
		{
			this.token = this.$route.params.token;
			this.client_user_uid = this.$route.params.client_user_uid;

			register
				.register_check(this.$route.params.client_user_uid, this.$route.params.token)
				.then((res) => {
					this.$notify({
						group: "info",
						title: "Email validé, vous pouvez maintenant vous connecter",
						type: "success",
					});
					this.$router.push({ name: "login" });
				})
				.catch((err) => {
					this.error = true;
					this.errorMsg = err;
				});
		}
	};
</script>

<style>
	.baground {
		margin-right: 250px;
	}
	.logo {
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
